import gql from "graphql-tag";

export const getInputTypes = gql`
  query GetInputType($typeName: String!) {
    __type(name: $typeName) {
      name
      inputFields {
        name
        type {
          name
          kind
          ofType {
            name
            kind
          }
        }
        defaultValue
        description
      }
    }
  }
`;

export default {
  queries: {
    getInputTypes
  }
};
